import { signal } from "@preact/signals";

// Tema claro/oscuro: default = preferencia del sistema, override manual
// persistido en localStorage (flux.theme).
const STORAGE_KEY = "flux.theme";

function initialTheme() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "dark" || stored === "light") return stored;
  } catch { /* sin storage */ }
  return window.matchMedia?.("(prefers-color-scheme: dark)")?.matches ? "dark" : "light";
}

export const theme = signal("light");

export function applyTheme(value) {
  theme.value = value;
  document.documentElement.classList.toggle("dark", value === "dark");
  try { localStorage.setItem(STORAGE_KEY, value); } catch { /* ignore */ }
}

export function toggleTheme() {
  applyTheme(theme.value === "dark" ? "light" : "dark");
}

export function initTheme() {
  const value = initialTheme();
  theme.value = value;
  document.documentElement.classList.toggle("dark", value === "dark");
}
